import React from 'react';
import { Search } from 'lucide-react';
import { AudienceLevel, Industry, INDUSTRY_LABELS, INDUSTRY_ORDER, LEVEL_LABELS, LEVEL_ORDER } from '../../types/pathway';
import { SelectDropdown } from '../SelectDropdown';
import { ResetFiltersButton } from '../ResetFiltersButton';
export interface PathwaySortOption {
  value: string;
  label: string;
}
interface PathwayLibraryFiltersProps {
  searchLabel: string;
  searchPlaceholder: string;
  query: string;
  industry: Industry | 'all';
  role: AudienceLevel | 'all';
  topic: string;
  topics: string[];
  sort: string;
  sortOptions: PathwaySortOption[];
  isActive: boolean;
  onQueryChange: (value: string) => void;
  onIndustryChange: (value: Industry | 'all') => void;
  onRoleChange: (value: AudienceLevel | 'all') => void;
  onTopicChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onReset: () => void;
}
const topicLabel = (topic: string) => topic.charAt(0).toUpperCase() + topic.slice(1);

/** Shared discovery controls for saved and proven pathway libraries. */
export function PathwayLibraryFilters({
  searchLabel,
  searchPlaceholder,
  query,
  industry,
  role,
  topic,
  topics,
  sort,
  sortOptions,
  isActive,
  onQueryChange,
  onIndustryChange,
  onRoleChange,
  onTopicChange,
  onSortChange,
  onReset
}: PathwayLibraryFiltersProps) {
  return <div className="mb-4 flex flex-wrap items-end gap-3" data-id="element-1735" data-mp="w76udv4955ml">
      <label className="relative min-w-[15rem] flex-1 sm:max-w-xs" data-id="element-1736" data-mp="1ttdwmyd32lvs">
        <span className="sr-only" data-id="element-1737" data-mp="1ou1aygxy7kus">{searchLabel}</span>
        <Search size={15} aria-hidden="true" className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-1738" data-mp="1ovcdyejkkoku" />
        <input value={query} onChange={event => onQueryChange(event.target.value)} placeholder={searchPlaceholder} className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm text-gray-900 placeholder:text-gray-500 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-[#30718D]" data-id="element-1739" data-mp="1fu4h80wpbvsv" />
      </label>
      <SelectDropdown ariaLabel="Filter pathways by industry" size="sm" value={industry} onChange={value => onIndustryChange(value as Industry | 'all')} options={[{
      value: 'all',
      label: 'All industries'
    }, ...INDUSTRY_ORDER.map(value => ({
      value,
      label: INDUSTRY_LABELS[value]
    }))]} data-id="element-1740" data-mp="au676hazf0w0" />
      <SelectDropdown ariaLabel="Filter pathways by role" size="sm" scrollMenu value={role} onChange={value => onRoleChange(value as AudienceLevel | 'all')} options={[{
      value: 'all',
      label: 'All roles'
    }, ...LEVEL_ORDER.map(value => ({
      value,
      label: LEVEL_LABELS[value]
    }))]} data-id="element-1741" data-mp="3o0pwkjcy6xci" />
      <SelectDropdown ariaLabel="Filter pathways by topic" size="sm" scrollMenu value={topic} onChange={onTopicChange} options={[{
      value: 'all',
      label: 'All topics'
    }, ...topics.map(value => ({
      value,
      label: topicLabel(value)
    }))]} data-id="element-1742" data-mp="34cqs1q8z8mfj" />
      <SelectDropdown ariaLabel="Sort pathways" size="sm" value={sort} onChange={onSortChange} options={sortOptions} data-id="element-1743" data-mp="2uqfucopqgmyq" />
      <ResetFiltersButton label="Reset search" isActive={isActive} onReset={onReset} data-id="element-1744" data-mp="34nkigu352si6" />
    </div>;
}